import { render, staticRenderFns } from "./fixBox.vue?vue&type=template&id=e4f6bf9e&scoped=true&"
import script from "./fixBox.vue?vue&type=script&lang=js&"
export * from "./fixBox.vue?vue&type=script&lang=js&"
import style0 from "./fixBox.vue?vue&type=style&index=0&id=e4f6bf9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f6bf9e",
  null
  
)

export default component.exports